import { Helpers } from '../../helpers';
import { IRampType } from '../../interfaces/iramp-type';
import { ForecastHorizontal } from '../forecast-horizontal';

export class RampTypeBase {
  RampTypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ForecastHorizontal_InitialGasRampType?: Array<ForecastHorizontal> | null;
  ForecastHorizontal_InitialOilRampType?: Array<ForecastHorizontal> | null;
  ForecastHorizontal_ShutinGasRampType?: Array<ForecastHorizontal> | null;
  ForecastHorizontal_ShutinOilRampType?: Array<ForecastHorizontal> | null;

  constructor(item?: IRampType) {
    if (item) {

      this.RampTypeId = item.RampTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontal_InitialGasRampType = Helpers.createClassArray(ForecastHorizontal, item.ForecastHorizontal_InitialGasRampType);
      this.ForecastHorizontal_InitialOilRampType = Helpers.createClassArray(ForecastHorizontal, item.ForecastHorizontal_InitialOilRampType);
      this.ForecastHorizontal_ShutinGasRampType = Helpers.createClassArray(ForecastHorizontal, item.ForecastHorizontal_ShutinGasRampType);
      this.ForecastHorizontal_ShutinOilRampType = Helpers.createClassArray(ForecastHorizontal, item.ForecastHorizontal_ShutinOilRampType);
    }
  }
}